module.exports = __webpack_public_path__ + "static/feature-notification-14c38c40da6862062fae6dc6815fe726.png";